<button *ngIf="!isFindAnAgent && showAgentContact" class="contact-agent" mat-stroked-button (click)="contactAgent()">
  Contact Agent
</button>

<button
  *ngIf="authorizeService.canView('findAnAgent') && !this.appState.companyInfoValue?.hideFindAgent && isFindAnAgent"
  id="savepop_btn"
  [matMenuTriggerFor]="viewAgentDropDown"
  tabindex="8"
  name="save search"
  aria-label="save search"
  class="search-agent dropdown-toggle"
>
  Find an Agent
</button>

<mat-menu class="find_an_agent" #viewAgentDropDown="matMenu">
  <div class="side_submenu" (click)="$event.stopPropagation()">
    <div (keydown.tab)="$event.stopPropagation()">
      <div class="savedpop_base">
        <div class="clearfix"></div>
        <div class="savesearch_base">
          <form [formGroup]="agentFilterForm">
            <div class="row mt-4">
              <div class="col-md-10 col-sm-10 col-10">
                <h5>Find an Agent</h5>
              </div>
              <div class="col-md-2 col-sm-2 col-2">
                <button class="submenu_close" (click)="close()"></button>
              </div>
            </div>
            <div class="row">
              <div class="col-12 col-md-12">
                <mat-form-field class="w-100">
                  <mat-label> City or Zip </mat-label>
                  <input
                    matInput
                    type="text"
                    (addressComponents)="getAddressComponents($event)"
                    placeholder="City or Zip"
                    name="search property"
                    formControlName="searchAddress"
                    googleAutocomplete="(regions)"
                    autocomplete="off"
                  />
                  <mat-error *ngIf="searchAddressCtrl.hasError('message')">
                    Please select a location from dropdown</mat-error
                  >
                </mat-form-field>
              </div>

              <div class="col-12 col-md-12">
                <mat-form-field class="w-100">
                  <mat-label> Agent Name </mat-label>
                  <input matInput autocomplete="off" formControlName="searchName" placeholder="Agent Name" />
                </mat-form-field>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12 align-items-center mt-2">
                <button class="btn btn-primary btn-block" mat-flat-button color="primary" (click)="submit()">
                  Search
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</mat-menu>
